/* eslint-disable eqeqeq */
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Navigate } from "react-router-dom";
import toast from "react-hot-toast";

import { icons, INDEX_URL, logos } from "../../helpers/constants";
import { ContextDataProvider } from '../ContextData';
import AxiosSetup from '../../services/AxiosSetup';
import Routing from './Routing';
import { requestForToken, onMessageListener } from "../../helpers/firebaseConfig";

function MissingRoute(props){
	return <Navigate to={{pathname: INDEX_URL+'404'}} replace />
}

const Main = (props) => {
	
	const setFlavorTheme = () => {
		let bookmarkIcon = require(`../../assets/customer/${process.env.REACT_APP_ASSETS}/meta/bookmark.png`);
		let favIcon = require(`../../assets/customer/${process.env.REACT_APP_ASSETS}/meta/favicon.ico`);
		let link = document.querySelector("link[rel~='icon']");
		let savedIcon = document.querySelector("link[rel~='apple-touch-icon']");

		if (!link) {
			link = document.createElement("link");
			link.rel = "icon";
			document.getElementsByTagName("head")[0].appendChild(link);
		}
		if (!savedIcon) {
			savedIcon = document.createElement("apple-touch-icon");
			savedIcon.rel = "apple-touch-icon";
			document.getElementsByTagName("head")[0].appendChild(savedIcon);
		}
		savedIcon.href = bookmarkIcon;
		link.href = favIcon;
		document.title = `${process.env.REACT_APP_NAME}`;
	}

	// useEffect(() => {
	// 	requestForToken();

	// 	const unsubscribe = onMessageListener((payload) => {
	// 		const title = payload?.data?.title || payload?.notification?.title || "Notification";
	// 		const body = payload?.data?.body || payload?.notification?.body || "";
	// 		const payload_sound = payload?.data?.sound || payload?.notification?.sound || "error_3sec";
	// 		const audio = new Audio(`${process.env.REACT_APP_EXTENDED_URL}/notifications/${payload_sound}.wav`);
	// 		audio.play().catch(() => {
	// 			console.log("SOUND???")
	// 		// blocked until user has interacted with page
	// 		});
	// 		const toastMessage = (
	// 			<div onClick={() => toast.dismiss()} className="d-flex flex-column cursor-pointer">
	// 				<h4>{title}</h4>
	// 				<p>{body}</p>
	// 			</div>
	// 		)

	// 		toast(toastMessage, {
	// 			icon: <img className="size_20" src={logos.small} alt="" />,
	// 			duration: 10000
	// 		});
	// 	});

	// 	return () => {
	// 		if (unsubscribe) unsubscribe();
	// 	};
	// }, []);

	useEffect(() => {
		const manifestLink = document.querySelector('link[rel="manifest"]');
		manifestLink.href = `${process.env.PUBLIC_URL}/customer/${process.env.REACT_APP_ASSETS}/manifest.json`;
	  }, []);

	useEffect(() => {
		setFlavorTheme()
	}, [])


	const basename = process.env.REACT_APP_EXTENDED_URL ?? "/live"
	return (
		<Router basename={basename}>
			<ContextDataProvider>
			<AxiosSetup />
			<Routing />
			</ContextDataProvider>
		</Router>
	)
		
}


export default Main;
